module.exports = __webpack_public_path__ + "img/72.2.TN.d96f3d0a.png";